import React, { Fragment, useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row,} from "reactstrap";
import { TimePicker } from "react-time-picker";
import Select from "react-select";
import MenuItem from "react-select";
import { render } from "@testing-library/react";
import "../../../style/calendarclass.css";
import moment from "moment";
import api from "../../../apis/api";
import { faL } from "@fortawesome/free-solid-svg-icons";
import Notifications from "../../../components/common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";

const FormFieldEditLeaveTypeAll = React.memo((props) => {
  const { inputFields, formValidation ,intimeval,outtimeval,halfdayworkval,fulldayworkval,employeeType,requestTypeList,formData,reqType,selectedItem} = props;
  const [inputFieldsArr, setInputFieldsArr] = useState(null);
const[desoptions , setOptions] =useState([{}]);
const {toggle}=props.toggle;
let options=[];
const [radioButtonType, setRadioButtonType] = useState("");
const[dutyTypeId,setdutytypeId]=useState([]);
const[dutyType,setdutytype]=useState([]);
const[requestTypeId,setrequesttypeId]=useState([]);
const[requestType,setrequesttype]=useState([]);
const[employeeTypeId,setEmployeeTypeId]=useState(0);
const [Isminimumworkingdays, setIsminimumworkingdays] = useState(false);
const [IsFirstOccurance, setIsFirstOccurance] = useState(false);
const [FirstOccurance, setFirstOccurance] = useState(0);
const [timesinFirstOccurance, setTimesInFirstOccurance] = useState(0);
const [AfterFirstOccurance, setAfterFirstOccurance] = useState(0);
const [minimumworkingdays, setminimumworkingdays] = useState(0);
const [Isnooftimes, setIsnooftimes] = useState(false);
const [nooftimes, setnooftimes] = useState(0);
const [leavetype, setleavetype] = useState("");
const [leavePerYear, setLeavePerYear] = useState(0);
const [leaveCarryForwarded, setLeaveCarryForwarded] = useState(0);
const [leaveAppyPerYear, setLeaveAppyPerYear] = useState(0);
const [numberofleave,setnumberofleave] =useState(0);
const [numberofleaveperwork,setnumberofleavePerwork] =useState("");
const [IsServingNotice,setIsservingNoticeperiod] =useState(false);
const [IsmaximumAccumulation,setIsmaximumAccumulation] =useState(false);
const [IsminimumMaintained,setIsminimumMaintained] =useState(false);
const [maximumAccumulation,setmaximumAccumulation] =useState(0);
const [minimumMaintained,setminimumMaintained] =useState(0);
const [IsnofdaysperYear,setIsnofdaysperYear]=useState(false);
const [Isnofdaysperorganization,setIsnofdaysperorganization]=useState(false);
const [Isnofdaysperhalfyear,setIsnofdaysperhalfyear]=useState(false);
const [noofdaysperyear,setnoofdaysperyear] =useState(0);
const [noofdaysperOrganiz,setnoofdaysperOrganiz] =useState(0);
const [noofdutyperyear,setnoofdutyperyear] =useState(0);
const [noofdutyperhalfyear,setnoofdutyperhalfyear] =useState(0);
const [appliednoofduty,setappliednoofduty] =useState(0);
const [dutygender,setdutygender] = useState("");
const [leavegender,setleavegender] = useState("");
const [leavetypeid,setleavetypeid]=useState(0);
const [DaysToServeFromDOJ,setDaysToServeFromDOJ] =useState("");
const [DaysToServeInYear,setDaysToServeInYear] =useState("");
const [error, setError] = useState(null);
const [loaded, setLoaded] = useState(false);
   
const DarkBackground = styled.div`
display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
${(props) =>
  props.disappear &&
  css`
    display: block; /* show */
  `}
`;
  //  inputFields.map(function (desig) {
  //   if(desig.type=="multipleselect" && desig.option.length >0)
  //   {
  //     desig.option.map((el,i) =>{
  //      options.push({value: el.designationId, label: el.designationName }); 
  //     })
     
  //   }
       
  // })
  useEffect(() => {
if(formData)
{
  if(formData.val.requestType == "Duty")
  {
   setdutytypeId(formData.val.leaveTypeId == "" ? "" :formData.val.leaveTypeId);
   setdutytype(formData.val.type == "" ? "" :formData.val.type);
   setnoofdutyperyear(formData.val.noOfLeavesPerYear == "" ? "" :formData.val.noOfLeavesPerYear);
   setappliednoofduty(formData.val.noOfLeavesAppliedPerYear == "" ? "" :formData.val.noOfLeavesAppliedPerYear);
   setdutygender(formData.val.gender == "" ? "" :formData.val.gender);
  }
  else
  {

  }
  setleavetypeid(formData.val.leaveTypeId);
  setleavetype(formData.val.type == "" ? "" :formData.val.type);
  setLeaveCarryForwarded(formData.val.noOfLeavesCarryForwarded == 0 ? 0 :formData.val.noOfLeavesCarryForwarded);
  setLeaveAppyPerYear(formData.val.noOfLeavesAppliedPerYear == 0 ? 0 :formData.val.noOfLeavesAppliedPerYear);
  setIsnofdaysperYear(formData.val.isLeavesPerYear == false ? false :formData.val.isLeavesPerYear);
  setnoofdaysperyear(formData.val.noOfLeavesPerYear == 0 ? 0 :formData.val.noOfLeavesPerYear);
  setIsnofdaysperorganization(formData.val.isLeavesPerOrganization == false ? false :formData.val.isLeavesPerOrganization);
  setnoofdaysperOrganiz(formData.val.leavesPerOrganization == 0 ? 0 :formData.val.leavesPerOrganization);
  setIsminimumworkingdays(formData.val.isMinimumWorkingDays == false ? false :formData.val.isMinimumWorkingDays);
  
  setIsnofdaysperhalfyear(formData.val.isLeavesPerHalfYear == false ? false :formData.val.isLeavesPerHalfYear);
  setnoofdutyperhalfyear(formData.val.leavesPerHalfYear == 0 ? 0 :formData.val.leavesPerHalfYear);
  setDaysToServeFromDOJ(formData.val.daysToServeFromDOJ == null ? 0 : formData.val.daysToServeFromDOJ);
  setDaysToServeInYear(formData.val.daysToServeInYear == null ? 0 : formData.val.daysToServeInYear);
  setminimumworkingdays(formData.val.minimumWorkingDays == 0 ? 0 :formData.val.minimumWorkingDays);
  setIsnooftimes(formData.val.isNumberOfTime == false ? false :formData.val.isNumberOfTime);
  setnooftimes(formData.val.numberOfTimes == 0 ? 0 :formData.val.numberOfTimes);
  setIsservingNoticeperiod(formData.val.isServingNoticePeriodCondition == false ? false :formData.val.isServingNoticePeriodCondition);
  setnumberofleave(formData.val.noticePeriodPerDay == 0 ? 0 :formData.val.noticePeriodPerDay);
  setIsmaximumAccumulation(formData.val.isMaximumAccumulation == false ? false :formData.val.isMaximumAccumulation);
  setmaximumAccumulation(formData.val.maximumAccumulation == 0 ? 0 :formData.val.maximumAccumulation);
  setIsminimumMaintained(formData.val.isMinimumMaintainedBal == false ? false :formData.val.isMinimumMaintainedBal);
  setminimumMaintained(formData.val.minimumMaintainedBalance == 0 ? 0 :formData.val.minimumMaintainedBalance);
  setleavegender((formData.val.gender == 0 ||formData.val.gender =='') ? '' :formData.val.gender);
  setEmployeeTypeId(formData.val.employeeTypeId);
  setIsFirstOccurance(formData.val.isFirstOccurance);
  setTimesInFirstOccurance(formData.val.timesinFirstOccurance == 0 ? 0 :formData.val.timesinFirstOccurance);
  setFirstOccurance(formData.val.firstOccurance == 0 ? 0 :formData.val.firstOccurance);
  setAfterFirstOccurance(formData.val.afterFirstOccurance == 0 ? 0 :formData.val.afterFirstOccurance)
  // setLeaveCarryForwarded(formData.)
}
  },[formData]);

  let intim=moment(intimeval, "hhmma").format("HH:mm");
  let outtim=moment(outtimeval, "hhmma").format("HH:mm");
  const onchangerequesttype= React.useCallback((e,val) =>{
    setrequesttype(val);
  });
  const onchangeisminimumdays= React.useCallback((e) =>{
    setIsminimumworkingdays(!Isminimumworkingdays);
    if(Isminimumworkingdays == true)
    {
      setminimumworkingdays("");
    }
  },[Isminimumworkingdays]);
  const onchangeservingnoticeperiod =React.useCallback((e) =>{
   setIsservingNoticeperiod(!IsServingNotice);
  },[IsServingNotice]);
  const onchangemaximumaccumulation =React.useCallback((e) => {
   setIsmaximumAccumulation(!IsmaximumAccumulation);
  },[IsmaximumAccumulation]);
  const onchangeminimummaintainbalance =React.useCallback((e) => {
    setIsminimumMaintained(!IsminimumMaintained);
  },[IsminimumMaintained])
  const onchangeisnooftimes= React.useCallback((e) =>{
    setIsnooftimes(!Isnooftimes);
    if(Isnooftimes == true)
    {
      setnooftimes("");
    }
  },[Isnooftimes]);
  const toggleradiobutton =React.useCallback((e) => {
    if(e==1)
    {
     setIsnofdaysperYear(true);
     setIsnofdaysperorganization(false);
     setIsnofdaysperhalfyear(false);
    }
    else if(e==2)
    {
      setIsnofdaysperYear(false);
      setIsnofdaysperorganization(true);
      setIsnofdaysperhalfyear(false);
    }
    else
    {
      setIsnofdaysperYear(false);
      setIsnofdaysperorganization(false);
      setIsnofdaysperhalfyear(true);
    }
  });
const toggleleaveradiobutton =(e) => {
  if(e==1)
  {
    setleavegender("Female");
  }
  else
  {
    setleavegender("Male");
  }
};
  const toggledutyradiobutton =React.useCallback((e) => {
    if(e==1)
    {
     setdutygender("Female");
    }
    else
    {
      setdutygender("Male");
    
    }
  });
  const submitLeave = async (e) => {
    setLoaded(true);
    e.preventDefault();
    let formData = {};
    formData = {
      LeaveTypeId: parseInt(leavetypeid),
      Type: leavetype,
      NoOfLeavesPerYear: parseInt(noofdaysperyear),
      NoOfLeavesCarryForwarded: parseInt(leaveCarryForwarded),
      NoOfLeavesAppliedPerYear: parseInt(leaveAppyPerYear),
      // DaysToServeFromDOJ: parseInt(DaysToServeFromDOJ),
      // DaysToServeInYear: parseInt(DaysToServeInYear),
      Gender: leavegender,
      TotalAccumulation: parseInt(0),
      IsLeavesPerYear: IsnofdaysperYear,
      IsLeavesPerOrganization: Isnofdaysperorganization,
      LeavesPerOrganization: parseInt(noofdaysperOrganiz),
      IsLeavesPerHalfYear:Isnofdaysperhalfyear,
      LeavesPerHalfYear :parseInt(noofdutyperhalfyear),
      IsMinimumWorkingDays: Isminimumworkingdays,
      MinimumWorkingDays: parseInt(minimumworkingdays),
      IsNumberOfTime: Isnooftimes,
      NumberOfTimes: parseInt(nooftimes),
      IsServingNoticePeriodCondition: IsServingNotice,
      NoticePeriodPerDay: parseInt(numberofleave),
      IsMaximumAccumulation: IsmaximumAccumulation,
      MaximumAccumulation: parseInt(maximumAccumulation),
      IsMinimumMaintainedBal: IsminimumMaintained,
      MinimumMaintainedBalance: parseInt(minimumMaintained),
      EmployeeTypeId:parseInt(employeeTypeId),
      IsFirstOccurance :IsFirstOccurance,
      TimesinFirstOccurance :parseInt(timesinFirstOccurance),
      FirstOccurance :parseInt(FirstOccurance),
      AfterFirstOccurance :parseInt(AfterFirstOccurance),
      LeaveTypeMasterId:parseInt(selectedItem.id)
    }
    await api.dbLeaveTypes().AddEditLeaveTypes(formData);
    setError({ ...error, message: "Leave Updated..", status: 200 });
    setTimeout(() => { 
      window.location.reload();
      setLoaded(false);
  }, 3000);
  }
  const handlecancel=()=>{
    toggle();
  } 
  const callBackAfterValidation =async () => {
    // console.log("formValidation:", selectedLeaves.id);
   
    setLoaded(true);
          let formData = {
            DutyTypeId :parseInt(dutyTypeId),
            Type: selectedItem.leaveType,
            status : "",
            CarryForwarded :parseFloat(0),
            NoOfDaysPerYear:parseFloat(noofdutyperyear),
            AppliedPerYear: parseFloat(appliednoofduty),
            DaysToServeFromDOJ:parseInt(0),
            DaysToServeInYear:parseInt(0),
            TotalAccumulation:parseInt(0),
            Gender :dutygender,
            IsActive :"true",
            TypeID:parseInt(selectedItem.id),
          };
          await api.dbLeaveTypes().AddEditDutyTypes(formData);
          // setSelectedLeaves({ id: "", val: "" });
          setError({ ...error, message: "Duty Updated..", status: 200 });
          
        
        // toggle();
        setTimeout(() => { 
          window.location.reload();
          setLoaded(false);
      }, 3000);
       
  
};
  return (
    <Form>
        <Row form>
        <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">Request Type</Label>
          <Input type="select" name="leaveTypeId" className="form-control" onChange={(e) =>
            {for (let node of e.target.children) {
              if (node.value === e.target.value) {
                onchangerequesttype(e.target.value,node.getAttribute('data-id'));
              }
            }}} isDisabled={true}>  
 
                        <option value={0}>Select Request Type</option>
                        {requestTypeList.map((req, i) => (
                        <option
                        key={i}
                        value={req.requestTypeId} 
                        data-id={req.requestType}   
                        selected={
                            req.requestTypeId == formData.val.requestTypeId ? true : false
                          }                     
                        >
                        {req.requestType}
                        </option>
                       ))}    
                    </Input> 
          </FormGroup>
          </Col>
         
          </Row>
      {formData.val.requestType=="Leave" ? (<div>
        <Row form>
          <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">Employee Type</Label>
          <Input type="select" name="leaveTypeId" className="form-control" onChange={(e) => setEmployeeTypeId(e.target.value)}> 

                        <option value={0}>Select Employee Type</option>
                        {employeeType.map((emp, i) => (
                        <option
                        key={i}
                        value={emp.employeeTypeId}    
                        selected={
                          formData.val.employeeTypeId == emp.employeeTypeId ? true : false
                          }                     
                        >
                        {emp.employeeTypeValue}
                        </option>
                       ))}    
                    </Input> 
          </FormGroup>
          </Col>
        <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">Leave Type</Label>
          <Input
              type="text"
               value={leavetype}
               onChange={(e) => setleavetype(e.target.value)}
               placeholder="Leave Type"
            />
          </FormGroup>
          </Col>
          
          </Row>
          <Row form>
        <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Leaves Carry Forwarded</Label>
          <Input
              type="text"
              value={leaveCarryForwarded}
              placeholder="No of Leaves Carry Forwarded"
              onChange={(e) => setLeaveCarryForwarded(e.target.value)}
            />
          </FormGroup>
          </Col>
          <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Leave Applied Per Year</Label>
          <Input
              type="number"
              value={leaveAppyPerYear}
              placeholder="No of Leave Applied Per Year"
              onChange={(e) => setLeaveAppyPerYear(e.target.value)}
            />
          </FormGroup>
          </Col>
          </Row>
          <Row form>
          <Col md={6}>
          <FormGroup className="singlerow" check>
            <Label check className="radio-days">
              <Input type="radio" name="radio2" onClick={() =>toggleradiobutton(1)} checked={IsnofdaysperYear == true?true : false}/>Leaves Per Year </Label>
              <Label check className="radio-days">  
              <Input type="radio" name="radio2" onClick={() =>toggleradiobutton(2)} checked={Isnofdaysperorganization == true?true : false}/>Leaves During Service</Label>
              <Label check className="radio-days">  
              <Input type="radio" name="radio2" onClick={() =>toggleradiobutton(3)} checked={Isnofdaysperhalfyear == true?true : false}/>Leaves Per HalfYear</Label>
            </FormGroup>
          </Col>
       {IsnofdaysperYear == true ?(<Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Leaves Per Year</Label>
          <Input
              type="number"
              value={noofdaysperyear}
              placeholder="No of Leaves Per Year"
              onChange={(e) => setnoofdaysperyear(e.target.value)}
            
            />
          </FormGroup>
          </Col>) : (Isnofdaysperorganization ==true ? (<Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Leaves Per Organization</Label>
          <Input
              type="number"
              value={noofdaysperOrganiz}
              placeholder="No of Leaves Per Year"
              onChange={(e) => setnoofdaysperOrganiz(e.target.value)}
            />
          </FormGroup>
          </Col>) : (Isnofdaysperhalfyear == true ?(<Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Leaves Per HalfYear</Label>
          <Input
              type="number"
              value={noofdutyperhalfyear}
              placeholder="No of Leaves Per HalfYear"
              onChange={(e) => setnoofdutyperhalfyear(e.target.value)}
            />
          </FormGroup>
          </Col>) : null) )}   
          </Row>
          <br/>
          <Row form>
        <Col md={3}>
          <FormGroup className="singlerow">
          <Label for="exampleEmail">No of times in first occurance</Label>
          <Input
              type="checkbox"
              className="singleradio"
              value={IsFirstOccurance}
              onChange={(e) => onchangeisminimumdays(e.target.value)}
              checked={IsFirstOccurance == true?true : false}
            />
          </FormGroup>
          </Col>
          {IsFirstOccurance == true ? (<Col md={3}>
                                <FormGroup>
                                  <Label>No of times in first occurance</Label>
                                  <Input type="text"
                                   value={timesinFirstOccurance}
                                   placeholder="Times in first occurance"
                                   onChange={(e) => setTimesInFirstOccurance(e.target.value)}
                                  ></Input>
                                </FormGroup>
                              </Col>) : null} 
        {IsFirstOccurance == true ? (<Col md={3}>
            <FormGroup>
              <Label>No of leaves in first occurance</Label>
              <Input type="text"
               value={FirstOccurance}
               placeholder="Leaves in first occurance"
               onChange={(e) => setFirstOccurance(e.target.value)}
              ></Input>
            </FormGroup>
          </Col>) : null}  
          {IsFirstOccurance == true ? (<Col md={3}>
            <FormGroup>
              <Label>No of leaves after first occurance</Label>
              <Input type="text"
               value={AfterFirstOccurance}
               placeholder="After First Occurance"
               onChange={(e) => setFirstOccurance(e.target.value)}
              ></Input>
            </FormGroup>
          </Col>) : null}
          </Row>
          <Row form>
        <Col md={6}>
          <FormGroup className="singlerow">
          <Label for="exampleEmail">Minimum Working Days</Label>
          <Input
              type="checkbox"
              className="singleradio"
              value={Isminimumworkingdays}
              onChange={(e) => onchangeisminimumdays(e.target.value)}
              checked={Isminimumworkingdays == true?true : false}
            />
          </FormGroup>
          </Col>
        {Isminimumworkingdays == true ? (<Col md={6}>
            <FormGroup>
              <Label>Minimum Working Days</Label>
              <Input type="text"
               value={minimumworkingdays}
               placeholder="Minimum Working Days"
               onChange={(e) => setminimumworkingdays(e.target.value)}
              ></Input>
            </FormGroup>
          </Col>) : null}  
          </Row>
          <Row>
          <Col md={6}>
          <FormGroup className="singlerow">
          <Label for="exampleEmail">No of Times</Label>
          <Input
              type="checkbox"
              className="singleradio"
              value={Isnooftimes}
              onChange={(e) => onchangeisnooftimes(e.target.value)}
              checked={Isnooftimes == true?true : false}
            />
          </FormGroup>
          </Col>
        {Isnooftimes == true ? (<Col md={6}>
            <FormGroup>
              <Label>No of Times</Label>
              <Input type="text"
              value={nooftimes}
              onChange={(e) => setnooftimes(e.target.value)}
              placeholder="No of Times"
              ></Input>
            </FormGroup>
          </Col>) : null}  
          </Row>
          <Row>
            <Col md={6}>
            <FormGroup className="singlerow">
              <Label>Serving Notice Period</Label>
              <Input type="checkbox"
              className="singleradio"
              value={IsServingNotice}
              onChange={(e) => onchangeservingnoticeperiod(e.target.value)}
              checked={IsServingNotice == true?true : false}></Input>
            </FormGroup>
            </Col>
           {IsServingNotice == true ? (<Col md={6}>
              <FormGroup>
                <Row>
                <Col md={6}>
                <Label>Number Of Leaves</Label>
                <Input type="text" value={numberofleave} onChange={(e) => setnumberofleave(e.target.value)}></Input>
                </Col>
                <Col md={6}>
                <Label>Per Working Days</Label>
                <Input type="text" value={numberofleaveperwork} onChange={(e) =>setnumberofleavePerwork(e.target.value)}></Input>
                </Col>
                </Row>
               
              </FormGroup>
            </Col>) : null} 
          </Row>
          <Row>
            <Col md={6}>
            <FormGroup className="singlerow">
              <Label>Maximum Accumulation</Label>
              <Input type="checkbox"
              className="singleradio"
              value={IsmaximumAccumulation}
              onChange={(e) => onchangemaximumaccumulation(e.target.value)}
              checked={IsmaximumAccumulation == true?true : false}
              ></Input>
            </FormGroup>
            </Col>
           {IsmaximumAccumulation == true ? (<Col md={6}>
              <FormGroup>

                <Label>Number Of Maximum Accumulation</Label>
                <Input type="text" value={maximumAccumulation} onChange={(e) => setmaximumAccumulation(e.target.value)}></Input>
               
               
              </FormGroup>
            </Col>) : null} 
          </Row>
          <Row>
            <Col md={6}>
            <FormGroup className="singlerow">
              <Label>Minimum Maintained Balance</Label>
              <Input type="checkbox"
              className="singleradio"
              value={IsminimumMaintained}
              onChange={(e) => onchangeminimummaintainbalance(e.target.value)}
              checked={IsminimumMaintained == true?true : false}
              ></Input>
            </FormGroup>
            </Col>
           {IsminimumMaintained == true ? (<Col md={6}>
              <FormGroup>

                <Label>Minimum Maintained Balance</Label>
                <Input type="text" value={minimumMaintained} onChange={(e) => setminimumMaintained(e.target.value)}></Input>
               
               
              </FormGroup>
            </Col>) : null} 
          </Row>
          <Row>
            <Col md={6}>
            <FormGroup check>
            <Label check className="radio-days">
              <Input type="radio" name="radio1"  onClick={() =>toggleleaveradiobutton(1)} checked={leavegender == "Female" ? true : false}/>Female </Label>
              <Label check className="radio-days">  
              <Input type="radio" name="radio1"  onClick={() =>toggleleaveradiobutton(2)} checked={leavegender == "Male" ? true : false}/>Male</Label>
            </FormGroup>
            </Col>
          </Row>
          </div>) : 
          (formData.val.requestType=="Duty" ? (<div>
            <Row form>
          
        <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">Duty Type</Label>
          <Input
              type="text"
               value={dutyType}
               onChange={(e) => setdutytype(e.target.value)}
               placeholder="Duty Type"
            />
          </FormGroup>
          </Col>
          
          </Row>
          <Row form>
          <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Duty Per Year</Label>
          <Input
              type="number"
              value={noofdutyperyear}
              placeholder="No of Duty Per Year"
              onChange={(e) => setnoofdutyperyear(e.target.value)}
            />
          </FormGroup>
          </Col>
          <Col md={6}>
          <FormGroup>
          <Label for="exampleEmail">No of Duty Applied Per Year</Label>
          <Input
              type="number"
              value={appliednoofduty}
              placeholder="No of Duty Applied Per Year"
              onChange={(e) => setappliednoofduty(e.target.value)}
            />
          </FormGroup>
          </Col>
          </Row>
         
        
          <Row>
            <Col md={6}>
            <FormGroup check>
            {(dutygender === 'Female' || leavegender === 'Female') ? (<div>
                <Label check className="radio-days">
                <Input type="radio" name="radio1" onClick={() =>toggledutyradiobutton(1)} checked/>Female 
                </Label>
                <Label check className="radio-days">  
                <Input type="radio" name="radio1" onClick={() =>toggledutyradiobutton(2)}/>Male</Label>
                </div>) :( (dutygender === 'Male' || leavegender === 'Male') ? (<div>
                  <Label check className="radio-days">
                  <Input type="radio" name="radio1" onClick={() =>toggledutyradiobutton(1)}/>Female 
                  </Label>
                <Label check className="radio-days">
                <Input type="radio" name="radio1" onClick={() =>toggledutyradiobutton(2)} checked/>Male 
                </Label>
                </div>):(<div>
                  <Label check className="radio-days">
                  <Input type="radio" name="radio1" onClick={() =>toggledutyradiobutton(1)}/>Female 
                  </Label>
                <Label check className="radio-days">
                <Input type="radio" name="radio1" onClick={() =>toggledutyradiobutton(2)}/>Male 
                </Label>
                </div>))}
              
            
            </FormGroup>
            </Col>
          </Row>
          </div>) : null)
}
          <br/>
    {formData.val.requestType == "Duty" ? ( <div><Button
        color=""
        className="btn-admin-settings"
        onClick={callBackAfterValidation}
      >
       Update
      </Button>{" "}
      &nbsp;
      <Button color="" className="btn-cancel" onClick={props.toggle}>
        Cancel
      </Button></div>) : (formData.val.requestType =="Leave" ? ( <div><Button
        color=""
        className="btn-admin-settings"
        onClick={submitLeave}
      >
       Update
      </Button> {" "}
      &nbsp;
      <Button color="" className="btn-cancel" onClick={props.toggle}>
        Cancel
      </Button></div>) : (null))} 
      <Notifications notifications={error}></Notifications>
      <DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
    </Form>
  );
});

export default FormFieldEditLeaveTypeAll;
